import { FC, PropsWithChildren } from "react";
import { cn } from "../utils";
type THeaderProps = PropsWithChildren & {
  className?: string;
};
const Header: FC<THeaderProps> = props => {
  const {
    children,
    className
  } = props;
  return <header className={cn("container grid w-full grid-cols-[1fr_minmax(50px,200px)_1fr] px-6 pt-4", className)} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      {children}
    </header>;
};
type HeaderTitleProps = PropsWithChildren & {
  className?: string;
  id?: string;
};
export const HeaderTitle: FC<HeaderTitleProps> = props => {
  const {
    children,
    className,
    id
  } = props;
  return <div id={id} className={cn("flex items-center justify-center text-sm font-bold text-black", className)} data-sentry-component="HeaderTitle" data-sentry-source-file="Header.tsx">
      {children}
    </div>;
};
export default Header;